(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vf-promo-layers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* vf-promo-layers slider: previous / next, dots, swipe, autoplay (paused on hover, focus, hidden tab, off screen,
       and for reduced motion). A slide that is not shown gets is-off + inert and a vf:sync event, so
       assets/vf-promo-motion.js pauses its animation. */
    const init = (el) => {
      if (el.vfPls) return;
      el.vfPls = 1;
      const slides = [...el.querySelectorAll('.vf-pls__slide')];
      if (slides.length < 2) return;
      const track = el.querySelector('.vf-pls__track');
      const dots = [...el.querySelectorAll('[data-vf-dot]')];
      const rtl = getComputedStyle(el).direction === 'rtl';
      const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const every = (+el.dataset.autoplay || 0) * 1000;
      let cur = 0, timer = 0, hold = false, seen = false;
      const fill = (s) => {
        if (!s || !s.hasAttribute('data-vf-defer')) return;
        s.querySelectorAll('[data-vf-srcset]').forEach((e) => { e.srcset = e.dataset.vfSrcset; e.removeAttribute('data-vf-srcset'); });
        s.querySelectorAll('[data-vf-src]').forEach((e) => { e.src = e.dataset.vfSrc; e.removeAttribute('data-vf-src'); });
        s.removeAttribute('data-vf-defer');
        s.dispatchEvent(new Event('vf:ready'));
      };
      const later = () => setTimeout(() => fill(slides[1]), 1500);
      if (document.readyState === 'complete') later(); else addEventListener('load', later, { once: true });
      const arm = () => {
        clearTimeout(timer);
        if (every && !still && !hold && seen && !document.hidden) timer = setTimeout(() => show(cur + 1, 1), every);
      };
      const show = (to, dir) => {
        const i = (to + slides.length) % slides.length;
        if (i === cur) return arm();
        const out = slides[cur], inn = slides[i];
        fill(inn);
        fill(slides[(i + 1) % slides.length]);
        const shift = (dir || (i > cur ? 1 : -1)) * (rtl ? -4 : 4);
        inn.style.transition = 'none';
        inn.style.setProperty('--vf-off', shift + '%');
        inn.offsetWidth; // start the incoming slide on the "next" side
        inn.style.transition = '';
        out.style.setProperty('--vf-off', -shift + '%');
        out.classList.add('is-off');
        out.inert = true;
        inn.classList.remove('is-off');
        inn.inert = false;
        dots.forEach((d, j) => (j === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')));
        cur = i;
        [out, inn].forEach((s) => s.dispatchEvent(new Event('vf:sync')));
        arm();
      };
      el.querySelector('[data-vf-prev]').addEventListener('click', () => show(cur - 1, -1));
      el.querySelector('[data-vf-next]').addEventListener('click', () => show(cur + 1, 1));
      dots.forEach((d, i) => d.addEventListener('click', () => show(i)));
      el.querySelectorAll('[data-vf-prev], [data-vf-next], [data-vf-dot]').forEach((b) => b.addEventListener('pointerenter', () => slides.forEach(fill), { once: true }));
      if (window.Shopify && Shopify.designMode) slides.forEach(fill);
      el.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { hold = true; arm(); } });
      el.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { hold = false; arm(); } });
      el.addEventListener('focusin', () => { hold = true; arm(); });
      el.addEventListener('focusout', (e) => { if (!el.contains(e.relatedTarget)) { hold = false; arm(); } });
      document.addEventListener('visibilitychange', arm);
      new IntersectionObserver((es) => { seen = es[0].isIntersecting; arm(); }).observe(el);
      // swipe (touch): finger to the left = next in English, to the right = next in Arabic; the tap that ends a swipe opens nothing
      let x0 = null, y0 = 0, swiped = 0;
      track.addEventListener('pointerdown', (e) => { if (e.pointerType === 'touch') { x0 = e.clientX; y0 = e.clientY; } });
      track.addEventListener('pointercancel', () => { x0 = null; });
      track.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0, dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        swiped = Date.now();
        hold = false;
        show(cur + ((dx < 0) !== rtl ? 1 : -1), (dx < 0) !== rtl ? 1 : -1);
      });
      track.addEventListener('click', (e) => { if (Date.now() - swiped < 400) { e.preventDefault(); e.stopPropagation(); } }, true);
      // theme editor: selecting a slide block shows it
      document.addEventListener('shopify:block:select', (e) => {
        const i = slides.indexOf(e.target.closest && e.target.closest('.vf-pls__slide'));
        if (i > -1) { hold = true; show(i); }
      });
    };
    const all = (root) => root.querySelectorAll('[data-vf-pls]').forEach(init);
    all(document);
    document.addEventListener('shopify:section:load', (e) => all(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
